var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F6F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_10240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8827 57.2236C65.0747 57.2236 59.5547 62.7436 59.5547 69.557C59.5547 76.3703 65.0747 81.8903 71.888 81.8903C78.7014 81.8903 84.2213 76.3703 84.2213 69.557C84.2213 62.7436 78.7014 57.2236 71.8827 57.2236ZM79.44 71.557H73.8827V77.1143C73.8827 78.2183 72.9867 79.1143 71.8827 79.1143C70.7734 79.1143 69.8827 78.2183 69.8827 77.1143V71.557H64.3307C63.2267 71.557 62.3307 70.661 62.3307 69.557C62.3307 68.453 63.2267 67.557 64.3307 67.557H69.8827V62.005C69.8827 60.901 70.7787 60.005 71.8827 60.005C72.9867 60.005 73.8827 60.901 73.8827 62.005V67.557H79.44C80.5493 67.557 81.4454 68.453 81.4454 69.557C81.4454 70.661 80.5493 71.557 79.44 71.557Z",
    fill: "#26BAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0159 23L39.9066 31.6987L39.8853 49.144L42.4506 50.6293L44.9226 52.0613L54.9786 57.8853L65.0773 52.0693L67.5519 50.6453L70.0933 49.1813L70.1146 31.7387L55.0159 23ZM54.9812 54.8053L42.5546 47.608L42.5706 33.2427L55.0132 26.08L67.4453 33.2747L67.4293 47.6373L54.9812 54.8053Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9999 41.8663C57.8826 41.8663 60.2186 39.5303 60.2186 36.6503C60.2186 33.7703 57.8826 31.4316 54.9999 31.4316C52.1173 31.4316 49.7812 33.7703 49.7812 36.6503C49.7812 39.5303 52.1173 41.8663 54.9999 41.8663ZM54.9999 34.0983C56.4053 34.0983 57.5519 35.2423 57.5519 36.6503C57.5519 38.0556 56.4053 39.1996 54.9999 39.1996C53.5946 39.1996 52.4479 38.0556 52.4479 36.6503C52.4479 35.2423 53.5946 34.0983 54.9999 34.0983Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9999 45.8874C58.9306 45.8874 62.3893 47.4234 64.0559 49.5807L66.3599 48.2527C64.2453 45.2794 59.9759 43.2207 54.9973 43.2207C50.0239 43.2207 45.7626 45.274 43.6426 48.242L45.9439 49.5754C47.6186 47.418 51.0746 45.8874 54.9999 45.8874Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1307 52.1143L23.0213 60.8129L23 78.2609L25.5653 79.7463L28.0373 81.1783L38.0933 87.0023L48.192 81.1836L50.6667 79.7623L53.208 78.2983L53.2293 60.8556L38.1307 52.1143ZM38.096 83.9223L25.6693 76.7249L25.6853 62.3569L38.128 55.1943L50.56 62.3916L50.544 76.7543L38.096 83.9223Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1147 70.9779C40.9973 70.9779 43.3333 68.6446 43.3333 65.7646C43.3333 62.8846 40.9973 60.5459 38.1147 60.5459C35.232 60.5459 32.896 62.8846 32.896 65.7646C32.896 68.6446 35.232 70.9779 38.1147 70.9779ZM38.1147 63.2126C39.52 63.2126 40.6667 64.3566 40.6667 65.7646C40.6667 67.1699 39.52 68.3112 38.1147 68.3112C36.7093 68.3112 35.5627 67.1699 35.5627 65.7646C35.5627 64.3566 36.7093 63.2126 38.1147 63.2126Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1147 74.9997C42.0453 74.9997 45.504 76.5357 47.1707 78.693L49.4747 77.3677C47.36 74.3943 43.0907 72.333 38.112 72.333C33.1387 72.333 28.8773 74.389 26.7573 77.3543L29.0587 78.6877C30.7333 76.533 34.1893 74.9997 38.1147 74.9997Z",
    fill: "#898989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_10240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.e916fdc50e855e12e2d3fadd4dadcbc8.svg";
export { ForwardRef as ReactComponent };